import { makeStyles } from '@material-ui/core/styles';

const styles = theme => ({
    root: {

    }
});

export default makeStyles(styles);